import { makeStyles } from '@material-ui/styles'
import withProgress from 'core/components/progress/withProgress'
import Dropdown from 'core/elements/dropdown'
import useListAction from 'core/hooks/useListAction'
import Theme from 'core/themes/model'
import React, { useMemo } from 'react'
import { useSelector } from 'react-redux'
import { listDomains } from './actions'
import { rawDomainsSelector } from './selectors'

const AsyncDropdown = withProgress(Dropdown, { inline: true })

export default function DomainPickList({
  name = 'domains',
  label = 'Domain',
  value = 'default',
  disabled = false,
  fullWidth = true,
  ...rest
}) {
  const classes = useStyles()
  const { loading } = useListAction(listDomains)
  const domains = useSelector(rawDomainsSelector)
  const options = useMemo(() => {
    return domains.map((d) => ({
      label: d.name || d.id,
      value: d.id,
    }))
  }, [domains])

  return (
    <AsyncDropdown
      {...rest}
      name={name}
      label={label}
      compact={false}
      loading={loading}
      items={options}
      value={value}
      disabled={disabled}
      className={!fullWidth ? classes.dropdown : undefined}
    />
  )
}

const useStyles = makeStyles((theme: Theme) => ({
  dropdown: {
    maxWidth: '190px',
  },
}))
